import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
const currentPipelineIdSlice = createSlice({
  name: 'currentPipelineId',
  initialState,
  reducers: {
    pipelineChanged: (state, {
      payload: {
        objectTypeId,
        pipelineId
      }
    }) => {
      state[objectTypeId] = pipelineId;
    }
  }
});
export const {
  pipelineChanged
} = currentPipelineIdSlice.actions;
// the generated action type is not available on the type returned by the reducer
// we need to manually define the type for usage elsewhere
export const PIPELINE_CHANGED = 'currentPipelineId/pipelineChanged';
export const currentPipelineIdReducer = currentPipelineIdSlice.reducer;